import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const scamAlertBanner ={
    mobile: {
        width: "100vw",
        background: Color.Linen,
        display:"flex",
        flexDirection:"column",
        justifyContent: "center",
        alignItems: "center",
        header: {
            fontSize: "3.00vw",
            color: Color.Red,
            fontFamily: Font.Poppins,
            marginTop: "1vw",
            marginLeft: "2.5vw",
            marginRight: "1.8vw",
        },
        bodyMessage: {
            color: Color.Red,
            fontFamily: Font.Poppins,
            fontSize: "3.00vw",
            marginLeft: "2.5vw",
            marginRight: "1.8vw",
            marginBottom: "2vw"
        },
        boldText: {
            fontWeight: "bold" as "bold",
        },
        boldTextAndUnderline: {
            fontWeight: "bold" as "bold",
            textDecoration: "underline"
        }
    },
    desktop: {
        width: "100%",
        height: "3.81vw", 
        paddingTop: "0.3vw",
        paddingBottom: "0.3vw",      
        header: {
            marginTop: "0vw",
            fontSize: "0.93vw"
        },
        bodyMessage: {
            fontSize: "0.93vw",
             marginBottom: "0vw"
        }
    }
}